import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Form, InputGroup, Input, Button, Fade, Alert } from "reactstrap";
import img from "../assets/images/login-right-image.svg";

import instance from "../utils/apiUtils";
import { selectUser, loginAction } from "../store/actions/userActions";
import { getAccount, getUserByName, loginUser } from "../services/authService";
import { TextField } from "@mui/material";
import { getGroupByUser } from "../services/groupsService";

const LogIn = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector(selectUser);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Erreur d'Authentification");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    //if (userData) navigate("/dashboard/statictics");
  }, []);

  // Handle form submission
  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);

    try {
      // Send login request to the server
      const loginResponse = await loginUser({
        username,
        password,
        rememberMe: false,
      });

      if (loginResponse) {
        // Set authorization header for future API requests
        instance.defaults.headers[
          "Authorization"
        ] = `Bearer ${loginResponse.id_token}`;

        // Store the bearer token in local storage
        localStorage.setItem("bearerToken", loginResponse.id_token);

        // Fetch user data from the server

        const userResponse = await getAccount();

        if (userResponse.activated) {
          const isAdmin =
            userResponse.authorities.includes("ROLE_ADMIN") || false;
          const groupResponse = await getGroupByUser(userResponse.id);
          dispatch(
            loginAction({
              user: userResponse,
              isAdmin: isAdmin,
              group: groupResponse?.group,
            })
          );
          setError(false);
          navigate("/dashboard/readers");
        } else {
          setError(true);
          setErrorMessage("Votre compte n'est pas activé");
        }
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
      console.log(err);
    }

    setDisabled(false);
  };

  return (
    <>
      <div className="row flex_center w-100 m-auto">
        <div className="col-lg-5 col-sm-12">
          <img
            src={img}
            alt="logo"
            className="mx-auto"
            style={{ maxWidth: 500, maxHeight: 250 }}
          />
        </div>
        <div className="col-lg-3 col-12 bg-white text-dark p-4 rounded border">
          <Fade>
            {error ? (
              <Alert
                color="danger"
                isOpen={error}
                toggle={() => setError(!error)}
              >
                {errorMessage}
              </Alert>
            ) : null}
            <h1 className="h2 mb-4 text-center">Connexion</h1>
            <Form onSubmit={handleSubmit}>
              <InputGroup className="mb-3">
                <TextField
                  className="w-100"
                  size="small"
                  variant="outlined"
                  label="Adresse e-mail ou Nom d'utilisateur"
                  type="text"
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </InputGroup>
              <InputGroup className="mb-2">
                <TextField
                  className="w-100"
                  size="small"
                  variant="outlined"
                  label="Mot de passe"
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </InputGroup>
              {/* <div className="mt-1 mb-2">
                <Link to="/forgot-password" className="my-3">
                  Mot de passe oublié ?
                </Link>
              </div> */}
              <Button
                type="submit"
                color="success w-100 my-2"
                disabled={disabled}
              >
                Se connecter
              </Button>
            </Form>
          </Fade>
        </div>
      </div>
    </>
  );
};

export default LogIn;
